import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class VisitData<T = any> {
  private _api = inject(FsApi);


  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'visits',
      query,
      {
        key: 'visits',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `visits/${data.id}`,
      data,
      {
        key: 'visit',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visits',
      data,
      {
        key: 'visit',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `visits/${data.id}`,
      data,
      {
        key: 'visit',
        ...config,
      },
    );
  }

  public exportCsv(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      'visits/export/csv',
      data,
      {
        key: 'url',
        ...config,
      },
    );
  }

  public exportExcel(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      'visits/export/excel',
      data,
      {
        key: 'url',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
